import React, { createContext, useState } from 'react';
import useWindowDimensions from './components/Lk/useWindowDimensions';

const UserContext = createContext();

export const UserConsumer = UserContext.Consumer;


export const UserProvider = (props) => {
    const { children } = props;
    const [user, setUser] = useState({});
    const [openLeftMenu, setOpenLeftMenu] = useState(useWindowDimensions().width > 1024 ? true : false);
    const [clinic, setClinic] = useState({});
    const [appointment, setAppointment] = useState({});
    const [payType, setPayType] = useState();
    const [specializationId, setSpecializationId] = useState({});
    const [specializationName, setSpecializationName] = useState();
    const [cabinetName, setCabinetName] = useState();
    const [isDisabledNextBtn, setIsDisabledNextBtn] = useState(true);
    const [sendingCompanyId, setSendingCompanyId] = useState();             //  Направившая организация
    const [currentMenuItem, setCurrentMenuItem] = useState('defaultValue'); //  текущий пункт меню

    return (
        <UserContext.Provider
            value={{
                user, setUser,
                openLeftMenu, setOpenLeftMenu,
                clinic, setClinic,
                appointment, setAppointment,
                payType, setPayType,
                specializationId, setSpecializationId,
                specializationName, setSpecializationName,
                cabinetName, setCabinetName,
                isDisabledNextBtn, setIsDisabledNextBtn,
                sendingCompanyId, setSendingCompanyId,
                currentMenuItem, setCurrentMenuItem,
            }}
        >
            {children}
        </UserContext.Provider>
    )
}


export default UserContext;
